<template>
  <div :class="['social-share', 'right-btn', theme]">
    <div class="icon">
      <ui-ui-button-ico
        icon="share"
        :responsive-ico="true"
        :response-size="[16, 16, 16, 20, 20, 20]"
        size="medium"
        type="tertiary"
        stroke="#363EF8"
        @click="toggleShare"
      />
    </div>
    <div class="link">
      <ui-ui-link
        icon-before="share"
        :font-weight="400"
        size="medium"
        :responsive-ico="true"
        :response-size="[16, 16, 16, 20, 20, 20]"
        @click="toggleShare"
      >
        Поделиться
      </ui-ui-link>
    </div>
    <div
      class="social-share-container-wrapper"
      :class="{
        share,
        'social-share-container-wrapper__show': share,
      }"
    >
      <div class="social-share-popup-hvostik" />
      <div class="close-div" @click.prevent="toggleShare" />
      <div class="social-share-container">
        <div class="social-share-text-tablet">
          Поделиться
          <div class="icon-close" @click.prevent="toggleShare" />
        </div>
        <div class="social-icon-container">
          <span
            class="social-icon copy"
            :class="{ copy: !isCopy, 'copy-ok': isCopy }"
            @click.prevent="onCopy"
            >{{ isCopy ? 'Ссылка скопирована' : 'Скопировать ссылку' }}</span
          >
        </div>
        <div class="social-icon-container">
          <span class="social-icon vk" @click="toSocial(vkShareLink)">
            ВКонтакте
          </span>
        </div>
        <div class="social-icon-container">
          <span class="social-icon ok" @click="toSocial(okShareLink)">
            Одноклассники
          </span>
        </div>
        <div class="social-icon-container">
          <span class="social-icon tg" @click="toSocial(tgShareLink)">
            Telegram
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useRoute } from 'vue-router';
import { useMediaQueryStore } from '~/stores/mediaQuery';

export default defineComponent({
  name: 'SocialMediaShare',
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    image: {
      type: String,
    },
    theme: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const route = useRoute();
    const path = computed(() => route.path);
    const mediaStore = useMediaQueryStore();
    const isTablet = computed(() => mediaStore.isTablet);

    const share = ref<boolean>(false);
    const toggleShare = () => {
      if (isTablet.value) {
        share.value = !share.value;
      }
    };

    const isCopy = ref(false);

    const onCopy = async () => {
      if (window && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(location.href);
          if (!isCopy.value) {
            isCopy.value = true;
            setTimeout(() => {
              isCopy.value = false;
            }, 2000);
          }
        } catch (e) {}
      }
    };

    const href = `https://${import.meta.env.VITE_PRICE_HOST}${path.value}`;
    const vkShareLink = computed(
      () =>
        `https://vk.com/share.php?url=${href}&title=${
          props.title
        }&description=${props.description}${
          props.image ? `&image=${props.image}` : ''
        }`
    );
    const okShareLink = computed(
      () =>
        `https://connect.ok.ru/offer?url=${href}&title=${props.title}${
          props.image ? `&imageUrl=${props.image}` : ''
        }`
    );
    const tgShareLink = computed(
      () => `https://t.me/share/url?url=${href}&text=${props.title}`
    );

    const toSocial = (url: string) => {
      window.open(url, '_blank');
    };

    return {
      toSocial,
      share,
      isCopy,
      onCopy,
      isTablet,
      toggleShare,
      vkShareLink,
      okShareLink,
      tgShareLink,
    };
  },
});
</script>
<style lang="scss" src="./SocialMediaShareScss.scss" scoped></style>
